import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bfc215a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "uk-modal-title" }, "Save selected workbooks as a group", -1))
const _hoisted_3 = { class: "dx-fieldset" }
const _hoisted_4 = { class: "dx-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dx-field-label" }, "Group Name", -1))
const _hoisted_6 = { class: "dx-field-value" }
const _hoisted_7 = {
  key: 2,
  class: "uk-button uk-button-default uk-modal-close",
  type: "button"
}
const _hoisted_8 = { class: "flex-container" }
const _hoisted_9 = { class: "flex-container" }
const _hoisted_10 = { class: "flex-container" }
const _hoisted_11 = { class: "spinner-sync" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_loader_component = _resolveComponent("loader-component")!
  const _component_default_dialog = _resolveComponent("default-dialog")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.dataSource !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_default_dialog, {
          class: "modal",
          "is-visible": _ctx.isVisible,
          "should-expand": false,
          "onUpdate:isVisible": _ctx.visibilityChanged
        }, {
          title: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_DxTextBox, {
                    value: _ctx.groupName,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupName) = $event))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          buttons: _withCtx(() => [
            (_ctx.isRunning)
              ? (_openBlock(), _createBlock(_component_loader_component, {
                  key: 0,
                  class: "uk-margin-remove"
                }))
              : _createCommentVNode("", true),
            (!_ctx.isRunning)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "uk-button uk-button-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveGroup && _ctx.saveGroup(...args))),
                  type: "button"
                }, "Save"))
              : _createCommentVNode("", true),
            (!_ctx.isRunning)
              ? (_openBlock(), _createElementBlock("button", _hoisted_7, "Cancel"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-visible", "onUpdate:isVisible"]),
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.dataSource,
          ref: _ctx.gridRefName,
          height: 440,
          width: 600,
          "key-expr": "id",
          "show-borders": true,
          "allow-column-resizing": true,
          onSelectionChanged: _ctx.onSelectionChanged
        }, {
          groupingTemplate: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_DxButton, {
                width: 50,
                hint: "Clear Selection",
                icon: "clear",
                type: "primary",
                "styling-mode": "contained",
                onClick: _ctx.clear
              }, null, 8, ["onClick"])
            ])
          ]),
          refreshbutton: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_DxButton, {
                width: 50,
                hint: "Refresh Data Grid",
                icon: "refresh",
                type: "primary",
                "styling-mode": "outlined",
                onClick: _ctx.refresh
              }, null, 8, ["onClick"])
            ])
          ]),
          templateSelection: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DxSelectBox, {
                width: 200,
                items: _ctx.groups,
                "display-expr": "name",
                "value-expr": "id",
                onValueChanged: _ctx.groupChanged
              }, null, 8, ["items", "onValueChanged"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxFilterRow, { visible: true }),
            _createVNode(_component_DxScrolling, { mode: "virtual" }),
            _createVNode(_component_DxColumn, {
              "data-field": "name",
              "data-type": "string"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "site.name",
              caption: "Site",
              "data-type": "string"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "project.name",
              caption: "Folder",
              width: "100"
            }),
            _createVNode(_component_DxSelection, {
              "show-check-boxes-mode": "always",
              mode: "multiple"
            }),
            _createVNode(_component_DxToolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  location: "after",
                  template: "templateSelection"
                }),
                _createVNode(_component_DxItem, {
                  location: "after",
                  template: "refreshbutton"
                }),
                _createVNode(_component_DxItem, {
                  location: "after",
                  template: "groupingTemplate"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-source", "onSelectionChanged"]),
        _withDirectives(_createVNode(_component_DxButton, {
          class: "run-button-css",
          width: 120,
          hint: "Save Selected Workbooks As A Group",
          text: "Save",
          icon: "save",
          type: "default",
          "styling-mode": "outlined",
          onClick: _ctx.saveGroupPopUp,
          disabled: this.selectedRowsData.length <= 0
        }, null, 8, ["onClick", "disabled"]), [
          [_vShow, !_ctx.startedRunning]
        ]),
        _withDirectives(_createElementVNode("span", _hoisted_11, null, 512), [
          [_vShow, _ctx.startedRunning]
        ])
      ]))
    : _createCommentVNode("", true)
}